import { LoadableAfterPaint } from '@confluence/loadable';
import type { ComponentType } from 'react';

export const OverviewNotFound = LoadableAfterPaint({
	loader: async () =>
		// eslint-disable-next-line
		(await import(/* webpackChunkName: "loadable-OverviewNotFound" */ '../src/OverviewNotFound'))
			.OverviewNotFound as ComponentType<any>,
});
